<template>
  <a
    :href="member.href"
    class="company-public-member"
    target="_blank"
  >
    <BasicAvatar
      class="company-public-member__avatar"
      :image="member.avatar"
      size="medium-smaller"
      roundness="full"
    />
    <span class="company-public-member__name">{{ member.fullName }}</span>
    <span
      v-if="member.position"
      class="company-public-member__position"
    >{{ member.position }}</span>
  </a>
</template>

<script>
  import BasicAvatar from 'src/components/BasicAvatar/BasicAvatar.vue';
  
  export default {
    name: 'CompanyPublicMember',
    components: { BasicAvatar },
    props: {
      member: {
        type: Object,
        required: true
      }
    },
  };
</script>